/**
 * Survey section
 */

(function($) {

    if ( typeof vous_l10n === 'undefined' ) { // Ensure l10n is set
        return;
    }
    if ( typeof vous_l10n.survey_form_id === 'undefined' || ! vous_l10n.survey_form_id ) { // Ensure script is enabled
        return;
    }

    // Triggers when page is loaded
    $(document).on('gform_page_loaded', function(event, form_id, current_page) {
        if ( form_id != vous_l10n.survey_form_id ) { // Apply only to the survey form
            return;
        }

        const $page = $(`#gform_page_${form_id}_${current_page}.js-survey-page-section`);
        if ( $page.filter(':visible').length == 0 ) { // Apply only to the current section page
            return;
        }

        // Automatically advance to the next page after timeout
        setTimeout(() => {
            $page.closest('form').trigger('submit', [true]);
        }, 3000);
    });

})(jQuery);
